import type { QueryExtraPropertiesArgs } from '@tribeplatform/gql-client/types'

import { KeyConstructor } from './keyConstructor.js'

const EXTRA_PROPERTIES_KEY = 'extraProperties'

export const getExtraPropertiesKey = KeyConstructor<
  QueryExtraPropertiesArgs,
  never
>(EXTRA_PROPERTIES_KEY)
